module.exports = __webpack_public_path__ + "static/media/icon-checklist-full@2x.dd314bd3.png";